<template>
  <img
    src="@/assets/images/coin.png"
    alt="coin"
  >
</template>